export default {
  roundtrip: {
    roundtripOptions: 'Rundreise-Optionen'
  }
}
